import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'TngSurveys'
}

const fetchAll = new Action('fetchAll', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

const fetchSurvey = new Action('fetchSurvey', {
  init: (id) => id,
  success: (data) => data,
})

const submitSurvey = new Action('submitSurvey', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

const select = new Action('select', {
  success: (survey) => ({ survey }),
})

const next = new Action('next', {})

const skip = new Action('skip', {
  success: (questionId) => ({ questionId }),
})

const answerQuestion = new Action('answerQuestion', {
  success: (questionId, value) => ({ questionId, value }),
})

const clearSurvey = new Action('clearSurvey', {
  success: () => ({}),
})

const setCurrentQuestionIndex = new Action('setCurrentQuestionIndex', {
  success: (questionIndex) => ({ questionIndex }),
})

const moveToNextQuestion = new Action('moveToNextQuestion', {
  success: () => ({}),
})

export default {
  select,
  next,
  skip,
  answerQuestion,
  fetchAll,
  fetchSurvey,
  submitSurvey,
  clearSurvey,
  setCurrentQuestionIndex,
  moveToNextQuestion,
}
